import React, { useState } from 'react';
import { ReactComponent as BrazilMap } from '../images/br.svg'; // Importe seu SVG do mapa do Brasil

const statesData = {
    'BRAM': { color: '#006837', name: 'Amazonas', cities: [{ name: 'Manaus', link: '' }] },
    'BRBA': { color: '#006837', name: 'Bahia', cities: [{ name: 'Camaçari', link: '' }] },
    'BRDF': { color: '#006837', name: 'Distrito Federal', cities: [{ name: 'Brasília', link: '' }] },
    'BRES': { color: '#006837', name: 'Espírito Santo', cities: [{ name: 'Vitória', link: '' }] },
    'BRSP': { color: '#006837', name: 'São Paulo', cities: [
            { name: 'ABC', link: '' },
            { name: 'Araçoiaba da Serra', link: '' },
            { name: 'Barueri', link: '' },
            { name: 'Campinas', link: '' },
            { name: 'Campinas Sul', link: '' },
            { name: 'Indaiatuba', link: '' },
            { name: 'Itu', link: '' },
            { name: 'Jundiaí', link: '' },
            { name: 'Limeira', link: '' },
            { name: 'Marília', link: '' },
            { name: 'Ribeirão Preto', link: '' },
            { name: 'São José do Rio Preto', link: '' },
            { name: 'São José dos Campos', link: '' },
            { name: 'São Paulo', link: '' },
            { name: 'São Paulo 3', link: '' },
            { name: 'Sertãozinho', link: '' },
            { name: 'Sorocaba', link: '' }
        ] },
    'BRRJ': { color: '#006837', name: 'Rio de Janeiro', cities: [{ name: 'Rio de Janeiro', link: '' }] },
    'BRGO': { color: '#006837', name: 'Goiás', cities: [{ name: 'Rio Verde', link: '' }] },
    'BRMG': { color: '#006837', name: 'Minas Gerais', cities: [
            { name: 'Belo Horizonte', link: '' },
            { name: 'Maringá', link: '' },
            { name: 'Nova Lima', link: '' },
            { name: 'Uberlândia', link: 'https://uberlandia.protegeobra.com.br/' },
            { name: 'Varginha', link: '' }
        ] },
    'BRMT': { color: '#006837', name: 'Mato Grosso', cities: [
            { name: 'Nova Mutum', link: '' },
            { name: 'Sinop', link: '' }
        ] },
    'BRMS': { color: '#006837', name: 'Mato Grosso do Sul', cities: [
            { name: 'Campo Grande', link: '' },
            { name: 'Dourados', link: '' }
        ] },
    'BRPR': { color: '#006837', name: 'Paraná', cities: [
            { name: 'Curitiba', link: '' },
            { name: 'Londrina', link: '' },
            { name: 'Maringá', link: '' },
            { name: 'Ponta Grossa', link: '' }
        ] },
    'BRRN': { color: '#006837', name: 'Rio Grande do Norte', cities: [{ name: 'Natal', link: '' }] },
    'BRRO': { color: '#006837', name: 'Rondônia', cities: [{ name: 'Porto Velho', link: '' }] },
    'BRRR': { color: '#006837', name: 'Roraima', cities: [{ name: 'Boa Vista', link: '' }] },
    'BRSC': { color: '#006837', name: 'Santa Catarina', cities: [
            { name: 'Balneário Camboriú', link: '' },
            { name: 'Porto Belo', link: '' }
        ] },
    'BRTO': { color: '#006837', name: 'Tocantins', cities: [{ name: 'Palmas', link: '' }] }
};
function Mapa() {
    const [selectedState, setSelectedState] = useState(null);
    const [hoveredState, setHoveredState] = useState(null);

    const handleStateClick = (state) => {
        if (statesData[state]) {
            setSelectedState(state);
        }
    };

    const handleMouseEnter = (state) => {
        setHoveredState(state);
    };

    const handleMouseLeave = () => {
        setHoveredState(null);
    };

    return (
        <div className="flex flex-col md:flex-row items-start">
            <div className="w-full md:w-1/2 flex justify-center">
                <BrazilMap
                    onClick={(e) => {
                        const state = e.target.id;
                        if (statesData[state]) {
                            handleStateClick(state);
                        }
                    }}
                    onMouseEnter={(e) => handleMouseEnter(e.target.id)}
                    onMouseLeave={handleMouseLeave}
                    style={{ width: '500px', height: '500px', maxWidth: '100%', maxHeight: '100%' }}
                    className="brazil-map"
                />
            </div>
            <div className="w-full md:w-1/2 mt-4 md:mt-0 md:ml-8">
                {selectedState ? (
                    <div className="cities-list">
                        <h3 className="text-lg font-semibold mb-2">
                            Franquias em {statesData[selectedState].name}:
                        </h3>
                        <ul className="list-disc pl-5">
                            {statesData[selectedState].cities.map((city) => (
                                <li key={city.name} className="mb-2">
                                    {city.link !== '#' && city.link !== '' ? (
                                        <a
                                            href={city.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 hover:underline"
                                        >
                                            {city.name}
                                        </a>
                                    ) : (
                                        <span className="text-gray-500">{city.name}</span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p className="text-gray-500">Selecione um estado para ver as franquias disponíveis.</p>
                )}
            </div>
            <style>
                {`
                    .brazil-map .state {
                        fill: #CCCCCC;
                        transition: fill 0.3s ease;
                    }
                    ${Object.keys(statesData)
                    .map(
                        (state) =>
                            `#${state} { fill: ${
                                hoveredState === state
                                    ? '#66BB6A' // Cor ao passar o mouse
                                    : selectedState === state
                                        ? '#174ac5' // Cor ao clicar
                                        : statesData[state].color
                            }; }`
                    )
                    .join('')}
                    .brazil-map .state:hover {
                        fill: #66BB6A;
                    }
                `}
            </style>
        </div>
    );
}

export default Mapa;
